import React from 'react';
import usePhoneSystem from '../hooks/usePhoneSystem';
import { styles } from './phone/phoneStyles';
import { NewsApp, SmsApp, MailApp, StocksApp, SettingsApp } from './phone/PhoneApps';
import PhoneDetail from './phone/PhoneDetail';

// 底部导航栏图标组件
const PhoneIcon = ({ icon, active, unread, onClick }) => (
  <div onClick={onClick} style={{ position: 'relative', cursor: 'pointer', padding: '5px', transition: 'opacity 0.2s', opacity: active ? 1 : 0.5 }}>
    <div style={{ fontSize: 22 }}>{icon}</div>
    {unread > 0 && (
      <div style={{ position: 'absolute', top: 0, right: 0, background: '#f44336', color: '#fff', fontSize: 9, fontWeight: 'bold', borderRadius: '50%', minWidth: 16, height: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #222', transform: 'translate(25%, -25%)' }}>
        {unread > 99 ? '99+' : unread}
      </div>
    )}
  </div>
);

export default function PhoneOS({ isMobile, phoneData, activeApp, unread, state, openApp, onPhoneAction }) {
  // 🌟 核心逻辑全部交由 Hook 管理
  const phone = usePhoneSystem(phoneData, activeApp, state, onPhoneAction);

  // 手机物理边框样式适配
  const containerStyle = isMobile ? {
    width: '100%', height: '100%', background: 'transparent', display: 'flex', flexDirection: 'column'
  } : {
    width: '320px', height: '650px', background: '#000', border: '14px solid #222', borderRadius: '36px',
    boxShadow: '0 0 20px rgba(0,0,0,0.5)', position: 'relative', display: 'flex', flexDirection: 'column', overflow: 'hidden'
  };

  return (
    <div style={containerStyle}>
      {/* 物理状态栏 (PC专属) */}
      {!isMobile && (
        <div style={styles.statusBar}>
          <span style={{ fontSize: 11 }}>10:24 PM</span>
          <div style={{ display: 'flex', gap: 5, fontSize: 11 }}>
            <span style={{ color: '#aaa' }}>5G</span><span>🔋 100%</span>
          </div>
        </div>
      )}

      {/* 手机屏幕主显示区 */}
      <div style={styles.screen}>
        {!phone.detail ? (
          <>
            {activeApp === 'news' && <NewsApp phoneData={phoneData} newsTab={phone.newsTab} setNewsTab={phone.setNewsTab} handleOpenDetail={phone.handleOpenDetail} />}
            {activeApp === 'sms' && <SmsApp phoneData={phoneData} state={state} handleOpenDetail={phone.handleOpenDetail} getLastMessageText={phone.getLastMessageText} />}
            {activeApp === 'mail' && <MailApp phoneData={phoneData} handleOpenDetail={phone.handleOpenDetail} />}
            {activeApp === 'stocks' && <StocksApp state={state} handleTrade={phone.handleTrade} />}
            {activeApp === 'settings' && <SettingsApp state={state} />}
          </>
        ) : (
          <PhoneDetail {...phone} />
        )}
      </div>

      {/* 物理 Home 栏/Dock 栏 (PC专属) */}
      {!isMobile && (
        <div style={styles.dock}>
          <PhoneIcon icon="✉️" active={activeApp === 'mail'} unread={unread.mail} onClick={() => openApp('mail')} />
          <PhoneIcon icon="💬" active={activeApp === 'sms'} unread={unread.sms} onClick={() => openApp('sms')} />
          <PhoneIcon icon="📱" active={activeApp === 'news'} unread={unread.news} onClick={() => openApp('news')} />
          <PhoneIcon icon="📈" active={activeApp === 'stocks'} unread={0} onClick={() => openApp('stocks')} />
          <PhoneIcon icon="⚙️" active={activeApp === 'settings'} unread={unread.settings} onClick={() => openApp('settings')} />
        </div>
      )}
    </div>
  );
}